(function () {
  if (window.__productAgeGroupSwitcherInitialized) return;
  window.__productAgeGroupSwitcherInitialized = true;

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-family-switch-product-url]');
    if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;

    const productUrl = input.dataset.familySwitchProductUrl;
    if (!productUrl || window.location.pathname === productUrl) return;

    window.location.assign(productUrl);
  });
})();
